import { createActionGroup, props } from '@ngrx/store';

import { LegalDocument } from '../../model/LegalDocument';
import { LegalDocumentApproval } from '../../model/LegalDocumentApproval';

export const LegalDocumentsActions = createActionGroup({
    source: 'LegalDocuments',
    events: {
        approvalLoaded: props<LegalDocumentApproval>(),
        signingRequested: props<{ documents: LegalDocument[] }>(),
        documentsApproved: props<{ documents: LegalDocument[] }>(),
    },
});
